import { observer } from 'mobx-react-lite';

import { IcStar48Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { CheckboxField, IconView, IconViewSizes, Portal } from '@gem/ui-kit';

import { BottomPopup } from 'APP/components/BottomPopup/BottomPopup';

import { useStarsFeedbackPresenter } from './StarsFeedback.presenter';
import styles from './StarsFeedback.styles.m.css';

export const StarsFeedback = observer(() => {
  const { t } = useTranslation();
  const presenter = useStarsFeedbackPresenter();

  if (!presenter.isShown) {
    return null;
  }

  return (
    <Portal>
      <BottomPopup
        onClose={presenter.onClose}
        className={styles.popup}
      >
        <div className={styles.title}>{t('heading_howd_the_call_go')}</div>
        <div className={styles.subTitle}>{t('description_tell_us_call_experience')}</div>
        <div className={styles.starsContainer}>
          {presenter.starsArray.map((star) => (
            <button
              key={star}
              className={styles.star}
              onClick={(): void => presenter.onStarClick(star)}
            >
              <IconView
                Icon={IcStar48Icon}
                size={IconViewSizes.XXLarge}
              />
            </button>
          ))}
        </div>
        <CheckboxField
          className={styles.dontShowContainer}
          onChange={presenter.onDontShowChange}
          value={presenter.isDontShowChecked}
          label={t('button_dont_show_me_again')}
        />
      </BottomPopup>
    </Portal>
  );
});
